import React, {
  useState,
  createContext,
  Dispatch,
  SetStateAction
} from "react";
import { InstallationItem } from "../global/types";

interface InstallationContextOptions {
  installationItems: InstallationItem[];
  setInstallationItems: Dispatch<SetStateAction<InstallationItem[]>>;
}

export const InstallationContext = createContext<InstallationContextOptions>({
  installationItems: [],
  setInstallationItems: () => [],
});

export const InstallationProvider: React.FC = ({ children }) => {
  const [installationItems, setInstallationItems] = useState<InstallationItem[]>([]);

  return (
    <InstallationContext.Provider value={{ installationItems, setInstallationItems }}>
      {children}
    </InstallationContext.Provider>
  );
};
